import React from "react";
import FastMarquee from "react-fast-marquee";

const Marquee = () => {
  const items = [
    "📢 Latest News",
    "🚗 New Cars Available",
    "🔥 Special Discounts",
    "📞 Contact Us Today",
  ];

  return (
    <FastMarquee speed={50} pauseOnHover>
        <div className="marquee">
            {items.map((item, index) => (
                <span key={index} style={{ marginRight: "50px" }}>
                {item}
                </span>
            ))}
        </div>
    </FastMarquee>
  );
};

export default Marquee;